var exports = {
  "P": "projectWrapper__gt49CN",
};

module.exports = exports;
